import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';

import { types } from '../../../types/types';
import { AuthContext } from '../../../reducers/auth/AuthContext';

import { CgSmartHomeWashMachine } from 'react-icons/cg';
import { FaDesktop } from 'react-icons/fa';
import { AiOutlineBank, AiOutlineCloseCircle, AiOutlineLayout, AiOutlineMail, AiOutlinePlusCircle, AiOutlineUserAdd } from 'react-icons/ai';
import Modal from 'react-bootstrap/Modal';
import SignupScreen from '../../auth/SignupScreen/SignupScreen';
import Swal from 'sweetalert2';

export const DashboardNav = ({ handleShow }) => {
	const { dispatch, user } = useContext(AuthContext);
	const [currentNav, setCurrentNav] = useState();

	const handleLogout = async () => {
		await dispatch({ type: types.logout });
		localStorage.removeItem('default-token');
		localStorage.removeItem('default-user');
	};
	const [show, setShow] = useState(false);
	const handleCloseCat = () => setShow(false);
	const handleOpenCat = () => setShow(true);
	const deploy = () => {
		fetch(process.env.REACT_APP_DEPLY_LINK)
			.then(response => Swal.fire('¡Bien!', 'La web se ha subido correctamente', 'success'))
			.catch(response => {
				console.log(response);
				Swal.fire('¡Mèrde!', 'La web no se ha subido', 'error');
			});
	};

	return (
		<>
			<nav className='dash-nav '>

				<Link to='/mbr' onClick={ () => setCurrentNav('') }>
					<figure>
						<img src={ process.env.REACT_APP_COMPANY_LOGO_BN } alt='' />
					</figure>
				</Link>

				<ul>
					<li>
						<Link to='/mbr/empresa' onClick={ () => setCurrentNav('empresa') }><AiOutlineBank className={ currentNav === 'empresa' ? 'active' : null } /><span>Empresa</span></Link>
					</li>
					<li>
						<Link to='/mbr/maquinaria' onClick={ () => setCurrentNav('maquinaria') }><CgSmartHomeWashMachine className={ currentNav === 'maquinaria' ? 'active' : null } /><span>Maquinaria</span></Link>
					</li>
					<li>
						<Link to='/mbr/mensajes' onClick={ () => setCurrentNav('mensajes') }><AiOutlineMail className={ currentNav === 'mensajes' ? 'active' : null } /><span>Mensajes</span></Link>
					</li>
					<li>
						<Link to='/mbr/seccion' onClick={ () => setCurrentNav('secciones') }><AiOutlineLayout className={ currentNav === 'secciones' ? 'active' : null } /><span>Secciones</span></Link>
					</li>
				</ul>
				<div className='btn-group'>
					<AiOutlineUserAdd onClick={ handleOpenCat } />
					{
						(user.email === 'admin@yai.com' || user.email === 'innova@mecanicabranosera.es') && (
							<FaDesktop className='fix-size' onClick={ deploy } />
						)
					}

					{ user.email === 'admin@yai.com' && (
						<AiOutlinePlusCircle onClick={ handleShow } />
					) }
					<AiOutlineCloseCircle onClick={ handleLogout } />
				</div>
				<Modal centered show={ show } onHide={ handleCloseCat }>
					<Modal.Header closeButton>
						<h4>Añadir Usuario nuevo</h4>
					</Modal.Header>
					<Modal.Body>
						<SignupScreen setShow={ setShow } />
					</Modal.Body>
				</Modal>

			</nav>
		</>
	);
};
